<template>
  <v-row>
    <v-col cols="12">
      <h2 @click="playSound()">{{ $t("ranking.head2") }}</h2>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title> {{ $t("ranking.head_list2") }} </v-card-title><v-spacer/>
        <v-card-actions class="pb-0 d-flex align-start">
          <v-row no-gutters><v-spacer/>
            <v-btn color="warning" @click="preloadExportCsv" class="">{{ $t("ranking.export_excel") }}</v-btn>
            <div style="margin-right: 10px;"></div>
            <v-btn color="warning" @click="linkToTop50" class="">{{ $t("ranking.ranking") }}</v-btn>
          </v-row>

        </v-card-actions>
        <br />
        <v-card-actions class="pb-0 d-flex align-start">
          <v-row no-gutters>
            <div style="margin-right: 20px;"><b>{{$t('ranking.role')}}</b></div>
              <div >
              <label  v-for="option in rankList"  :key="option.id" style="margin-right: 30px;vertical-align: center;" >
                <input  type="radio"  :value="option.id" @click="searchUserRadio(option.id)"   v-model="rankSelect" style="margin-right: 3px;"/>{{ option.name }}
              </label>
            </div>
          </v-row>
        </v-card-actions>
        <br />
        <v-card-actions class="pt-0">
          <v-data-table mobile-breakpoint="0" style="width: 100%" :headers="headers" :no-data-text="$t('not_found')"
            :no-results-text="$t('not_found')" :options.sync="pagination" :server-items-length="pagination.totalItems"
            :items-per-page="pagination.rowsPerPage" :page.sync="pagination.currentPage" :loading="loading" :footer-props="{
              'items-per-page-options': [10, 25, 30, 40, 50],
            }" :items="members">
            <template v-slot:[`item.exp`]="{ item }">
              <div class="amount-col">
                <span > {{ item.exp | currency }}</span>
              </div>
            </template>
            <template v-slot:[`item.deposit`]="{ item }">
              <div class="amount-col">
                <span class="success--text"> {{ item.deposit | currency }}</span>
              </div>
            </template>
            <template v-slot:[`item.withdraw`]="{ item }">
              <div class="amount-col">
                <span class="error--text"> {{ item.withdraw | currency }}</span>
              </div>
            </template>
            <template v-slot:[`item.profit`]="{ item }">
              <div class="amount-col">
                <span class="success--text" v-if="(item.profit > 0)"> {{ item.profit | currency }}</span>
                <span class="error--text" v-if="(item.profit < 0)"> {{ item.profit | currency }}</span>
                <span  v-if="(item.profit === 0)"> {{ item.profit | currency }}</span>
              </div>
            </template>
          </v-data-table>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import DatePickerInput from '@/components/input/DatePickerInput.vue'
import SelectInput from '@/components/input/SelectInput.vue'
import store from '@/store'
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { addLogExportCSV } from '@/services/apis/logs'
import { mdiConsoleNetwork } from '@mdi/js'
export default {
  components: {
    DatePickerInput,
    SelectInput,
  },

  data() {
    return {
      headers: [
        {
          text: this.$t("ranking.header2_1"),
          value: 'no',
          width: '100px',
          sortable: false,
        },
        {
          text: this.$t("ranking.header2_2"),
          value: 'exp',
          width: '100px',
          sortable: false,
        },
        {
          text: this.$t("ranking.header2_3"),
          value: 'nickname',
          width: '100px',
          sortable: false,
        },
        {
          text: this.$t("ranking.header2_4"),
          value: 'phone',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("ranking.header2_5"),
          value: 'username',
          width: '95px',
          sortable: false,
        },
        {
          text: this.$t("ranking.header2_6"),
          value: 'rankName',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("ranking.header2_7"),
          value: 'deposit',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("ranking.header2_8"),
          value: 'withdraw',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("ranking.header2_9"),
          value: 'profit',
          align: 'center',
          sortable: false,
        },
      ],
      members: [],
      rankList:[{
            "id": 1,
            "name": "Season EXP"
        },
        {
            "id": 2,
            "name": "Casino"
        },
        {
            "id": 3,
            "name": "Slot"
        },
        {
            "id": 4,
            "name": "Sport"
        },
        {
            "id": 5,
            "name": "Lotto"
        }],
      rankSelect:1,
      rank:1,
      loading: false,
      canEdit: true,
      pagination: {
        currentPage: 1,
        rowsPerPage: 50,
        totalItems: 0,
      },
    }
  },

  async created() {
    this.getWebSettingInfo()
    this.addLogPage()
  },

  watch: {
    pagination: {
      async handler(newValue, oldValue) {
        let cont = false
        if (oldValue.page !== newValue.page) cont = true
        if (oldValue.itemsPerPage !== newValue.itemsPerPage) cont = true
        if (oldValue.sortBy !== newValue.sortBy) cont = true
        if (oldValue.sortDesc !== newValue.sortDesc) cont = true
        if (cont) await this.searchPaginate(newValue.page, newValue.itemsPerPage)
      },
      deep: true,
    },
  },

  methods: {
    async getWebSettingInfo() {
      try {
        let settingWebInfo = await this.$store.dispatch('getSettingWebInfo')
        this.bankSystem = settingWebInfo?.bank_system[0] || 'TH';
      } catch (e) { }
    },
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            name: 'สมาชิก',
            url: window.location.href,
            detail: 'ระบบแสดง top 50',
            admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
          }
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
      }
    },
    async getUsers(page, row, time_from, time_to, search) {

      this.loading = true
      this.members = []
      this.search='';
      switch(this.rank){
        case 1:search="exp";break;
        case 2:search="casino";break;
        case 3:search="slot";break;
        case 4:search="sport";break;
        case 5:search="lotto";break;
      }
      let rs = await this.$store.dispatch('getUserTop50', { key:search})
      this.pagination.totalItems = rs.count;

      rs.data.forEach(element => {
        this.members.push({
          no: element.ranking_no,
          exp: element.season_exp,
          nickname: element.nickname ? element.nickname : '',
          phone: element.phone ? element.phone : '',
          username: element.username,
          commissionRoleId: element.commission_role_id,
          rankName: element.rank_name,
          deposit:element.deposit,
          withdraw:element.withdraw,
          profit:Math.floor((element.deposit-element.withdraw)*100)/100,
        })
      })

      this.loading = false
    },
    async searchPaginate(page, row) {
      await this.getUsers(page, row, this.startDate, this.endDate, this.searchData)
    },
    async searchUserRadio(id) {
      this.rank=id;
      await this.getUsers(1, this.pagination.itemsPerPage, this.startDate, this.endDate, this.searchData)
      this.pagination.currentPage = 1
    },
    linkToTop50() {
      this.$router.push({ name: 'ranking', params: { } })
    },
    async preloadExportCsv() {
      await this.addLogExportCSV(true)
      //////// get logExportData ////////
      let logExportData;
      const userSystem = store.getters.getuserInfo
      await axios.get('https://api.ipify.org?format=json').then(res =>
        logExportData = {
          ip: res.data.ip,
          exportPage: 'สมาชิก - ระบบแสดง top 50',
          url: window.location.href,
          detail: 'ระบบแสดง top 50',
          admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
        }
      )

      this.$swal({
        title: `Secure code | รายงาน${logExportData.exportPage}`,
        input: 'password',
        // inputAttributes: {
        //   inputmode: 'numeric',
        //   pattern: '[0-9]*',
        //   maxlength: 6,
        // },
        inputValidator: value => {
          if (!value) {
            return 'โปรดกรอก Secure code'
          }
          // if (value && value.length !== 6) {
          //   return 'โปรดกรอกให้ครบ 6 หลัก'
          // }
        },
        inputPlaceholder: 'ใส่รหัสที่นี่...',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ออก',
      }).then(async result => {
        if (result.isConfirmed) {
          const pin = result.value
          let enterSecureData = {
            ...logExportData,
            keyCheck: pin
          }
          this.loading = true
          let resEnterSecureData = await this.$store.dispatch('checkLogEnterSecure', enterSecureData)
          if (resEnterSecureData && resEnterSecureData.secure) {
            this.exportCsv()
          } else {
            this.$swal.fire('ไม่สามารถ download ได้ เนื่องจากรหัส PIN ไม่ถูกต้อง', '', 'error')
          }
          this.loading = false
        }
      })
    },
    async exportCsv() {
      this.$swal.fire({
        html: this.$t("processing"),
        timerProgressBar: true,
        didOpen: () => { this.$swal.showLoading() }
      })

      let fileName = `${this.$t("ranking.file_name_top50")}_${moment(new Date()).format('YYYY-MM-DD_HH-mm')}`
      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const wscols = [
        { wch: 15 },
        { wch: 25 },
        { wch: 10 },
        { wch: 10 },
        { wch: 20 },
        { wch: 20 },
        { wch: 15 },
      ];
      let statementlist = []
      this.search='';
      switch(this.rank){
        case 1:this.search="exp";break;
        case 2:this.search="casino";break;
        case 3:this.search="slot";break;
        case 4:this.search="sport";break;
        case 5:this.search="lotto";break;
      }
      let rs = await this.$store.dispatch('getUserTop50', { key:this.search})
      // console.log(rs.data);
      rs.data.forEach(element => {
        statementlist.push({
          no: element.ranking_no,
          exp: element.season_exp,
          nickname: element.nickname ? element.nickname : '',
          phone: element.phone ? element.phone : '',
          username: element.username,
          commissionRoleId: element.commission_role_id,
          rankName: element.rank_name,
          deposit:element.deposit,
          withdraw:element.withdraw,
          profit:Math.floor((element.deposit-element.withdraw)*100)/100,
        })
      })
      let ws = XLSX.utils.json_to_sheet(statementlist);
      ws['!cols'] = wscols;
      const wb = { Sheets: { Top50: ws }, SheetNames: ["Top50"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);

      // add log admin export
      await this.addLogExportCSV()
      this.$swal.close()
    },
    async addLogExportCSV(isClick=false) {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            exportPage: 'สมาชิก - ระบบแสดงลำดับของผู้เล่น',
            url: window.location.href,
            detail: 'ระบบแสดงลำดับผู้เล่น',
            admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
            isClick: isClick,
          }
        )
        await this.$store.dispatch('addLogExportCSV', data)
      } catch (e) {
        if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
          this.$swal.fire({
            icon: 'error',
            title: e.message,
          })
        }
      }
    },
    playSound() {
      this.$store.dispatch('setPlaySound', true)
    },
  },
}
</script>
<style scoped>
@media (max-width: 550px) {
  .spacer {
    width: 100%;
  }
}
</style>
